/* global angular:false */

(function () {
    "use strict";

    angular.module("vendd")
    .controller('CheckoutDeliveryPointWidgetController', function ($scope, $q, $element, ControlService) {
        $scope.Model = $scope.Model || {};
        $scope.Control = $scope.Control || {};

        var controlName = 'DeliveryPointWidget';
        $scope.registerControl(controlName, $element.get(0));
        
        //var applyModel = function () {            
        //    $scope.setControlValue(controlName, $scope.Model);
        //};

        ControlService.getCheckoutData("GetDeliveryPointWidgetData", $scope, $element).then(function (response) {
            $scope.Model = {};
            angular.extend($scope.Model, response);
            //applyModel();
            $scope.Control.Loading = false;
        }, function (error) {
            $scope.Control.Loading = false;
            throw error;
        });
    });
})();